<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
      </h4>
    </div>

    <div v-if="!loaded">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5">
              <select
                v-model="profileTypeFilter"
                class="form-control"
                required
              >
                <option value="ALL">
                  {{ $t('companyVendors.btnProfillr') }}
                </option>
                <option value="SUPPLIER">
                  {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                </option>
                <option value="LOGISTIC">
                  {{ $t('companyFormEdit.logistiklrN') }}
                </option>
                <option value="TRUCK">
                  {{ $t('companyFormEdit.trSahiblriN') }}
                </option>
              </select>
            </div>
            <div
              v-if="profileTypeFilter==='SUPPLIER' || profileTypeFilter ==='ALL'"
              class="col-md-3"
            >
              <select
                v-model.number="sectorFilter"
                class="form-control"
              >
                <option value="0">
                  {{ $t('companyVendors.btnSektorlar') }}
                </option>
                <option
                  v-for="s in sectorList"
                  :value="s.id"
                >
                  {{ s.name }}
                </option>
              </select>
            </div>

            <div class="col-md-2">
              <select
                v-model="countryFilter"
                class="form-control"
              >
                <option value="ALL">
                  {{ $t('companyVendors.hamisi') }}
                </option>
                <option
                  v-for="country in countryList"
                  :key="country"
                  :value="country"
                >
                  {{ country }}
                </option>
              </select>
            </div>

            <div class="col-md-2 text-right">
              <button
                class="btn btn-primary"
                @click="addVendorToList"
              >
                {{ $t('companyVendors.birBasaVendorListeElaveEt') }}
              </button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <input
                v-model="vendorNameFilter"
                type="text"
                class="form-control"
                :placeholder="$t('companyVendors.vendorAdiniFilterleyin')"
              >
            </div>
            <div class="col-md-6">
              <select
                v-model="vendorSortOrder"
                class="form-control"
              >
                <option value="asc">
                  A–Z
                </option>
                <option value="desc">
                  Z–A
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="list-group list-group-flush">
          <div
            v-if="filteredVendors.length<1"
            class="list-group-item"
          >
            <div v-if="sectorFilter>0 || profileTypeFilter !=='ALL'">
              {{ $t('companyVendors.axtraraUyunNticTaplmad') }}
            </div>
            <div v-else>
              {{ $t('companyVendors.tsdiqlnmiTdarkYoxdur') }}
            </div>
          </div>
          <div
            v-for="v in filteredVendors"
            :key="v.verifiedCompany.taxId"
            class="list-group-item"
          >
            <!-- 1-ci sətir -->
            <div class="row">
              <!-- 1) Şirkət adı və VÖEN -->
              <div class="col-md-4 mb-3">
                <strong>
                  {{ v.verifiedCompany.name }}
                  {{ getCompanyFormat(v.verifiedCompany.format) }}
                </strong>
                <br>
                {{ $t('supplierOutgoingVendorRequest.ven') }}
                <em>{{ v.verifiedCompany.taxId }}</em>
                <br>
                <button 
                  class="btn btn-air-info btn-sm "
                  @click.prevent="getCompanyAdditionalDetails(v.id)"
                >
                  <i class="fa fa-info-circle mr-1" />{{ $t('companyVendors.detalliMelumat') }}
                </button>
              </div>

              <!-- 2) Profile type və sektorlar -->
              <div class="col-md-4 mb-3">
                <div v-if="v.profileType === 'LOGISTIC'">
                  {{ $t('companyVendors.logistikSorularNTsdiqlnmidir') }}
                </div>
                <div v-if="v.profileType === 'TRUCK'">
                  {{ $t('companyVendors.trlarlaBalSorularNTsdiqlnmidir') }}
                </div>
                <div
                  v-for="s in v.sectors"
                  :key="s.sector.id"
                >
                  <span
                    :class="{
                      'font-weight-bold':
                        sectorFilter > 0 && sectorFilter === s.sector.id
                    }"
                  >
                    - {{ s.sector.name }}
                  </span>
                  <a
                    v-if="s.companyFormRequest"
                    href="#"
                    @click.prevent="showRequestDetails(s.companyFormRequest.id)"
                  >
                    {{
                      $t('supplierOutgoingVendorRequest.mracit', {
                        id: s.companyFormRequest.id
                      })
                    }}
                  </a>
                </div>
              </div>

              <!-- 3) Tarixi dəyiş düyməsi -->
              <div class="col-md-1 text-left">
                <!-- Əgər formRequest varsa -->
                <template v-if="v.sectors[0]?.companyFormRequest">
                  <button
                    class="btn btn-air-info"
                    @click="v.isDatePickerOpen = !v.isDatePickerOpen"
                  >
                    {{ $t('companyVendors.tarixiDeyis') }}
                  </button>
                  <div
                    v-if="v.isDatePickerOpen"
                    class="calendar-container mt-1"
                  >
                    <Datepicker
                      :value="v.sectors[0]?.companyFormRequest?.deadLineTime || Date.now()"
                      :monday-first="true"
                      @input="date => setDate(v.sectors[0].companyFormRequest.id, date)"
                    />
                  </div>
                </template>
                <!-- Əgər formRequest yoxdursa, amma expiryDate varsa -->
                <template v-else>
                  <div class="d-flex flex-column">
                    <button
                      class="btn btn-air-info mb-2"
                      @click="v.isDatePickerOpen = !v.isDatePickerOpen"
                    >
                      {{ $t('companyVendors.tarixiDeyis') }}
                    </button>
                    <button
                      v-if="v.profileType === 'SUPPLIER'"
                      class="btn btn-air-primary"
                      @click="openChangeSectorModal(v)"
                    >
                      {{ $t('companyVendors.sektoruDeyis') }}
                    </button>
                    <div
                      v-if="v.isDatePickerOpen"
                      class="calendar-container mt-1"
                    >
                      <Datepicker
                        :value="v.expiryDate || Date.now()"
                        :monday-first="true"
                        @input="date => setExpiryDate(v.id, date)"
                      />
                    </div>
                  </div>
                </template>
                <!-- Hər ikisi yoxdursa boş yer -->
              </div>


              <template v-if="v.sectors[0]?.companyFormRequest">
                <div
                  v-if="v.sectors[0]?.companyFormRequest?.status !== 'EXPIRED' && v.sectors[0]?.companyFormRequest?.deadLineTime"
                  class="col-md-2 text-right"
                >
                  <p class="font-weight-bold text-right text-black">
                    {{ $t('companyVendors.yenilenmeVarixi') }}
                    {{ v.sectors[0]?.companyFormRequest?.deadLineTime || v.sectors[0]?.companyFormRequest?.sendTime }}
                  </p>

                  <button
                    v-if="v.sectors[0].companyFormRequest.deadLineTime && (new
                      Date(v.sectors[0].companyFormRequest.deadLineTime) - Date.now()) < (10 * 24 * 60 * 60 * 1000)"
                    :class="[
                      'btn',
                      'btn-sm',
                      'text-blink',
                      new Date(v.sectors[0].companyFormRequest.deadLineTime) < Date.now() ? 'btn-danger' : 'btn-success'
                    ]"
                    @click="recallVendor(v.sectors[0]?.companyFormRequest?.id)"
                  >
                    {{ $t('companyVendors.formaYenilenmelidir') }}
                  </button>
                </div>
                <div
                  v-else-if="v.sectors[0]?.companyFormRequest?.status === 'EXPIRED'"
                  class="col-md-2 text-center"
                >
                  {{ $t('companyVendors.yenilenmeUcunGonderilmisdir') }}
                </div>
                <div
                  v-else
                  class="col-md-2 text-right"
                />
              </template>
              <template v-else-if="v.expiryDate">
                <div class="col-md-2 text-right">
                  <p class="font-weight-bold text-right text-black">
                    {{ $t('companyVendors.yenilenmeVarixi') }}
                    {{ v.expiryDate }}
                  </p>
                  <!-- İstəsək, expiryDate üçün də yeniləmə düyməsi əlavə etmək olar -->
                  <button
                    v-if="v.expiryDate && (new Date(v.expiryDate) - Date.now()) < (10 * 24 * 60 * 60 * 1000)"
                    :class="[
                      'btn',
                      'btn-sm',
                      'text-blink',
                      new Date(v.expiryDate) < Date.now() ? 'btn-danger' : 'btn-success'
                    ]"
                    @click="recallVendorExpiry(v.verifiedCompany.id,v.id)"
                  >
                    {{ $t('companyVendors.formaYenilenmelidir') }}
                  </button>
                </div>
              </template>
              <template v-else>
                <!-- Fallback: ensure we still render an empty col so layout remains consistent -->
                <div class="col-md-2 text-right" />
              </template>


              <!-- 5) Sil düyməsi -->
              <div class="col-md-1 text-right">
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteVendor(v.verifiedCompany.taxId)"
                >
                  {{ $t('general.delete') }}
                </button>
              </div>
            </div>

            <!-- 2-ci sətir (row) - CreatedBy məlumatı -->
            <div class="row mt-2">
              <div class="col-md-12">
                {{
                  $t('companyVendors.vcreatedbynameVcreatedbysurnameTrfindnNewDatevlogt', {
                    name: v.createdBy.name,
                    surname: v.createdBy.surname
                  })
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-vendor-request"
        size="xl"
        centered
        :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
        scrollable
        :hide-footer="true"
        class="theme-modal"
        :busy="false"
        :no-enforce-focus="true"
      >
        <VendorRequestDetailsReceiver
          v-if="activeRequestId>0"
          :active-request-id="activeRequestId"
          @confirmRequest="confirmRequest($event)"
        />
      </b-modal>


      <b-modal
        id="modal-request-confirm"
        size="lg"
        centered
        :title="$t('companyFormAdminView.mracitinTsdiqlnmsi')"
        scrollable
        :hide-footer="true"
        class="theme-modal"
        :busy="false"
        :no-enforce-focus="true"
        @close="getVendorList"
      >
        <ConfirmVendorRequestModal
          :confirm-request-details="confirmRequestDetails"
          @updated="showRequestDetails(confirmRequestDetails.requestId)"
        />
      </b-modal>
      <b-modal
        id="modal-change-sector"
        size="md"
        centered
        :title="$t('companyVendors.sektoruDeyis')"
        :busy="modalLoading"
        :hide-footer="true"
        @close="resetChangeSectorModal"
      >
        <div v-if="selectedVendor">
          <h5>{{ selectedVendor.verifiedCompany.name }}</h5>

          <!-- Sector Multiselect -->
          <div class="form-group">
            <label>{{ $t('vendorAddModal.sectorLabel') }}</label>
            <Multiselect
              v-model="selectedSectors"
              :options="sectorListAdd"
              :multiple="true"
              :track-by="'id'"
              :label="'name'"
              :placeholder="$t('vendorAddModal.sectorPlaceholder')"
            />
          </div>

          <button
            class="btn btn-success mt-3"
            :disabled="modalLoading"
            @click="updateVendorSectors"
          >
            {{ $t('companyVendors.yaddaSaxla') }}
          </button>
        </div>
      </b-modal>

      <b-modal
        id="modal-add-vendor"
        size="md"
        centered
        :title="$t('vendorAddModal.addVendorTitle')"
        :busy="modalLoading"
        :hide-footer="true"
        @close="resetModal"
      >
        <div class="form-group">
          <label for="companyName">{{ $t('vendorAddModal.companyNameLabel') }}</label>
          <input
            id="companyName"
            v-model="searchForm.name"
            type="text"
            class="form-control"
            :placeholder="$t('vendorAddModal.companyNamePlaceholder')"
          >
        </div>
        <div class="form-group">
          <label for="taxId">{{ $t('vendorAddModal.taxIdLabel') }}</label>
          <input
            id="taxId"
            v-model="searchForm.taxId"
            type="text"
            class="form-control"
            :placeholder="$t('vendorAddModal.taxIdPlaceholder')"
          >
        </div>
        <button
          class="btn btn-primary"
          :disabled="modalLoading"
          @click="searchCompany"
        >
          {{ $t('vendorAddModal.searchButton') }}
        </button>

        <div
          v-if="companies?.length"
          class="mt-3"
        >
          <h5>{{ $t('vendorAddModal.searchResultsTitle') }}</h5>
          <ul class="list-group">
            <li
              v-for="company in companies"
              :key="company.id"
              :class="{'list-group-item': true, 'active': company.id === selectedCompanyId}"
              style="cursor: pointer"
              @click="selectCompany(company)"
            >
              {{ company.name }} ({{ company.taxId }})
            </li>
          </ul>
        </div>

        <!-- Profile Type and Sector Selection after Company Selection -->
        <div
          v-if="selectedCompanyId"
          class="mt-3"
        >
          <h5>{{ $t('vendorAddModal.selectProfileType') }}</h5>
          <div class="form-group">
            <label for="profileType">{{ $t('vendorAddModal.profileTypeLabel') }}</label>
            <select
              id="profileType"
              v-model="selectedProfileType"
              class="form-control"
              required
              @change="onProfileTypeChange"
            >
              <option value="SUPPLIER">
                {{ $t('vendorAddModal.profileTypeOptions.supplier') }}
              </option>
              <option value="LOGISTIC">
                {{ $t('vendorAddModal.profileTypeOptions.logistic') }}
              </option>
              <option value="TRUCK">
                {{ $t('vendorAddModal.profileTypeOptions.truck') }}
              </option>
            </select>
          </div>

          <!-- Sector Multiselect (visible only if profile type is SUPPLIER) -->
          <div
            v-if="selectedProfileType === 'SUPPLIER'"
            class="form-group"
          >
            <label>{{ $t('vendorAddModal.sectorLabel') }}</label>
            <Multiselect
              v-model="selectedSectors"
              :options="sectorListAdd"
              :multiple="true"
              :track-by="'id'"
              :label="'name'"
              :placeholder="$t('vendorAddModal.sectorPlaceholder')"
            />
          </div>
        </div>
        <button
          v-if="selectedCompanyId"
          class="btn btn-success mt-3"
          :disabled="!selectedCompanyId"
          @click="addCompanyToVendor"
        >
          {{ $t('vendorAddModal.saveToVendorButton') }}
        </button>
      </b-modal>

      <!-- Modal for displaying additional vendor details -->
      <b-modal
        id="modal-vendor-details"
        size="lg"
        centered
        :title="$t('companyVendors.vendorDetails.vendorDetails')"
        scrollable
        :hide-footer="true"
        class="theme-modal"
        :busy="false"
        :no-enforce-focus="true"
      >
        <div v-if="vendorDetails">
          <!-- Company Information -->
          <div class="card mb-3">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0">
                {{ $t('companyVendors.vendorDetails.companyInformation') }}
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <p><strong>{{ $t('companyVendors.vendorDetails.companyName') }}</strong> {{ vendorDetails.companyName }}</p>
                  <p><strong>{{ $t('companyVendors.vendorDetails.voen') }}</strong> {{ vendorDetails.voen }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>{{ $t('companyVendors.vendorDetails.applyTime') }}</strong> {{ new Date(vendorDetails.apply_time).toLocaleString() }}</p>
                  <p><strong>{{ $t('companyVendors.vendorDetails.remainingStorage') }}</strong> {{ parseFloat(vendorDetails.storage).toFixed(3) }} MB</p>
                  <p><strong>{{ $t('companyVendors.vendorDetails.storage') }}</strong> {{ (15 - parseFloat(vendorDetails.storage)).toFixed(3) }} MB</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p><strong>{{ $t('companyVendors.vendorDetails.sectors') }}</strong></p>
                  <ul>
                    <li
                      v-for="(sector, index) in vendorDetails.sectors"
                      :key="index"
                    >
                      {{ sector }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Files Section -->
          <div class="card mb-3">
            <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                {{ $t('companyVendors.vendorDetails.files') }} ({{ vendorDetails.file_count }})
              </h5>
              <button
                class="btn btn-sm btn-light"
                @click="showAddFileForm = !showAddFileForm"
              >
                <i class="fa fa-plus" /> {{ $t('companyVendors.vendorDetails.addFile') }}
              </button>
            </div>
            <div class="card-body">
              <!-- Add File Form -->
              <div
                v-if="showAddFileForm"
                class="mb-3 p-2 border rounded compact-form-container"
              >
                <h6 class="mb-2 small-heading">
                  {{ $t('companyVendors.vendorDetails.addNewFile') }}
                </h6>
                <div class="form-group compact-form-group">
                  <label
                    for="fileTitle"
                    class="small-label"
                  >{{ $t('companyVendors.vendorDetails.title') }}</label>
                  <input
                    id="fileTitle"
                    v-model="newFile.title"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('companyVendors.vendorDetails.enterFileTitle')"
                  >
                </div>
                <div class="form-group compact-form-group">
                  <label
                    for="fileUpload"
                    class="small-label"
                  >{{ $t('companyVendors.vendorDetails.file') }}</label>
                  <div class="custom-file-upload">
                    <input
                      id="fileUpload"
                      ref="fileUpload"
                      type="file"
                      class="form-control-file"
                      @change="handleFileChange"
                    >
                    <div class="mt-2 text-center">
                      <small class="text-muted">{{ $t('companyVendors.vendorDetails.dropFilesHere') }}</small>
                    </div>
                  </div>
                  <small class="form-text text-muted small-hint">
                    {{ $t('companyVendors.vendorDetails.dragAndDropHint') }}
                  </small>
                </div>
                <div class="d-flex justify-content-end mt-2">
                  <button
                    class="btn btn-sm btn-secondary mr-2"
                    @click="showAddFileForm = false"
                  >
                    {{ $t('companyVendors.vendorDetails.cancel') }}
                  </button>
                  <button
                    class="btn btn-sm btn-success"
                    :disabled="!newFile.title || !newFile.file"
                    @click="addFile"
                  >
                    {{ $t('companyVendors.vendorDetails.save') }}
                  </button>
                </div>
              </div>

              <!-- Files Table -->
              <div
                v-if="vendorDetails.files && vendorDetails.files.length > 0"
                class="table-responsive"
              >
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ $t('companyVendors.vendorDetails.title') }}</th>
                      <th>{{ $t('companyVendors.vendorDetails.created') }}</th>
                      <th>{{ $t('companyVendors.vendorDetails.fileSize') }}</th>
                      <th>{{ $t('companyVendors.vendorDetails.source') }}</th>
                      <th>{{ $t('companyVendors.vendorDetails.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(file, index) in vendorDetails.files"
                      :key="index"
                    >
                      <td>{{ file.title }}</td>
                      <td>{{ new Date(file.created).toLocaleString() }}</td>
                      <td>{{ file.size ? parseFloat(file.size).toFixed(3) + ' MB' : '-' }}</td>
                      <td>
                        <a
                          v-if="file.source && !isNaN(file.source) && file.source.toString().trim() !== ''"
                          href="#"
                          @click.prevent="showRequestDetails(file.source)"
                        >
                          {{
                            $t('supplierOutgoingVendorRequest.mracit', {
                              id: file.source
                            })
                          }}
                        </a>
                        <template v-else>
                          {{ file.source }}
                        </template>
                      </td>
                      <td>
                        <a
                          :href="mediaBase + file.value"
                          target="_blank"
                          class="btn btn-sm btn-primary mr-2"
                        >
                          <i class="fa fa-download" /> {{ $t('companyVendors.vendorDetails.download') }}
                        </a>
                        <button
                          v-if="!file.readonly"
                          class="btn btn-sm btn-danger"
                          @click="deleteFile(file)"
                        >
                          <i class="fa fa-trash" /> {{ $t('companyVendors.vendorDetails.delete') }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p
                v-else
                class="text-center"
              >
                {{ $t('companyVendors.vendorDetails.noFilesAvailable') }}
              </p>
            </div>
          </div>

          <!-- Links Section -->
          <div class="card">
            <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                {{ $t('companyVendors.vendorDetails.links') }} ({{ vendorDetails.link_count }})
              </h5>
              <button
                class="btn btn-sm btn-light"
                @click="showAddLinkForm = !showAddLinkForm"
              >
                <i class="fa fa-plus" /> {{ $t('companyVendors.vendorDetails.addLink') }}
              </button>
            </div>
            <div class="card-body">
              <!-- Add Link Form -->
              <div
                v-if="showAddLinkForm"
                class="mb-4 p-3 border rounded"
              >
                <h6 class="mb-3">
                  {{ $t('companyVendors.vendorDetails.addNewLink') }}
                </h6>
                <div class="form-group">
                  <label for="linkTitle">{{ $t('companyVendors.vendorDetails.title') }}</label>
                  <input
                    id="linkTitle"
                    v-model="newLink.title"
                    type="text"
                    class="form-control"
                    :placeholder="$t('companyVendors.vendorDetails.enterLinkTitle')"
                  >
                </div>
                <div class="form-group">
                  <label for="linkUrl">{{ $t('companyVendors.vendorDetails.url') }}</label>
                  <input
                    id="linkUrl"
                    v-model="newLink.url"
                    type="url"
                    class="form-control"
                    :placeholder="$t('companyVendors.vendorDetails.enterUrl')"
                  >
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-secondary mr-2"
                    @click="showAddLinkForm = false"
                  >
                    {{ $t('companyVendors.vendorDetails.cancel') }}
                  </button>
                  <button
                    class="btn btn-info"
                    :disabled="!newLink.title || !newLink.url"
                    @click="addLink"
                  >
                    {{ $t('companyVendors.vendorDetails.save') }}
                  </button>
                </div>
              </div>

              <!-- Edit Link Form -->
              <div
                v-if="showEditLinkForm"
                class="mb-4 p-3 border rounded"
              >
                <h6 class="mb-3">
                  {{ $t('companyVendors.vendorDetails.editLink') }}
                </h6>
                <div class="form-group">
                  <label for="editLinkTitle">{{ $t('companyVendors.vendorDetails.title') }}</label>
                  <input
                    id="editLinkTitle"
                    v-model="editLink.title"
                    type="text"
                    class="form-control"
                    :placeholder="$t('companyVendors.vendorDetails.enterLinkTitle')"
                  >
                </div>
                <div class="form-group">
                  <label for="editLinkUrl">{{ $t('companyVendors.vendorDetails.url') }}</label>
                  <input
                    id="editLinkUrl"
                    v-model="editLink.url"
                    type="url"
                    class="form-control"
                    :placeholder="$t('companyVendors.vendorDetails.enterUrl')"
                  >
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-secondary mr-2"
                    @click="cancelEditLink"
                  >
                    {{ $t('companyVendors.vendorDetails.cancel') }}
                  </button>
                  <button
                    class="btn btn-info"
                    :disabled="!editLink.title || !editLink.url"
                    @click="updateLink"
                  >
                    {{ $t('companyVendors.vendorDetails.update') }}
                  </button>
                </div>
              </div>

              <!-- Links Table -->
              <div
                v-if="vendorDetails.links && vendorDetails.links.length > 0"
                class="table-responsive"
              >
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ $t('companyVendors.vendorDetails.title') }}</th>
                      <th>{{ $t('companyVendors.vendorDetails.created') }}</th>
                      <th>Mənbə</th>
                      <th>{{ $t('companyVendors.vendorDetails.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(link, index) in vendorDetails.links"
                      :key="index"
                    >
                      <td>{{ link.title }}</td>
                      <td>{{ new Date(link.created).toLocaleString() }}</td>
                      <td>
                        <a
                          v-if="link.source && !isNaN(link.source) && link.source.toString().trim() !== ''"
                          href="#"
                          @click.prevent="showRequestDetails(link.source)"
                        >
                          {{
                            $t('supplierOutgoingVendorRequest.mracit', {
                              id: link.source
                            })
                          }}
                        </a>
                        <template v-else>
                          {{ link.source }}
                        </template>
                      </td>
                      <td>
                        <a
                          :href="link.value"
                          target="_blank"
                          class="btn btn-sm btn-info mr-2"
                        >
                          <i class="fa fa-external-link" /> {{ $t('companyVendors.vendorDetails.open') }}
                        </a>
                        <button
                          v-if="!link.readonly"
                          class="btn btn-sm btn-primary mr-2"
                          @click="openEditLinkForm(link)"
                        >
                          <i class="fa fa-edit" /> {{ $t('companyVendors.vendorDetails.edit') }}
                        </button>
                        <button
                          v-if="!link.readonly"
                          class="btn btn-sm btn-danger"
                          @click="deleteLink(link)"
                        >
                          <i class="fa fa-trash" /> {{ $t('companyVendors.vendorDetails.delete') }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p
                v-else
                class="text-center"
              >
                {{ $t('companyVendors.vendorDetails.noLinksAvailable') }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-center py-4"
        >
          <div
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">{{ $t('companyVendors.vendorDetails.pleaseWait') }}</span>
          </div>
          <p class="mt-2">
            {{ $t('companyVendors.vendorDetails.loadingVendorDetails') }}
          </p>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getWorkingSectors, upload} from "@/repositories/GeneralDataRepository";
import {
  addCompanyToVendorManagment,
  addDeletedVendor,
  getVendorList,
  recallRequest,
  searchCompanyByNameOrTaxId,
  updateVendorDeadline,
  updateVendorExpiryDate,
  updateSectorForOne, 
  getCompanyAdditionalDetails,
  addVendorFile,
  updateVendorFile,
  deleteVendorFile,
  handleErrors,
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import VendorRequestDetailsReceiver from "@/pages/scc/vendorManagement/VendorRequestDetailsReceiver.vue";
import ConfirmVendorRequestModal from "@/pages/scc/vendorManagement/ConfirmVendorRequestModal.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";

import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
    CompanyFormRequestStatus,
    ConfirmVendorRequestModal,
    VendorRequestDetailsReceiver,
    CompanyFormStatus, 
    Multiselect
  },
  data() {
    return {
      mediaBase: mediaBase,
      loaded: false,
      vendors: [],
      form: null,
      sectors: [],
      sections: [],
      inputs: [],
      faq: [],
      faqAnswerText: '',
      formLink: '',
      showCalendar: false,

      requests: [],
      activeRequestId: 0,
      confirmRequestDetails: null,
      sectorListAdd: [],
      detailedInfo: null,
      vendorDetails: null, // Store the vendor details response
      showAddFileForm: false,
      showAddLinkForm: false,
      newFile: {
        title: '',
        file: null
      },
      newLink: {
        title: '',
        url: ''
      },
      editingLink: null,
      showEditLinkForm: false,
      editLink: {
        title: '',
        url: ''
      },
      sectorFilter: 0,
      profileTypeFilter: 'ALL',
      modalLoading: false,
      searchForm: {
        name: '',
        taxId: ''
      },
      companies: [],
      selectedCompanyId: null,
      selectedProfileType: 'SUPPLIER', // Default profile type
      selectedSectors: [], // Selected sectors when profile type is SUPPLIER
      vendorNameFilter: '',
      vendorSortOrder: 'asc',
      countryFilter: 'ALL', // Default country filter
      selectedVendor: null // Selected vendor for changing sectors
    }
  },
  watch: {
    "$route"() {
      this.sectorFilter = parseInt(this.$route.query['sectorId'] || 0);
      this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
    },
    profileTypeFilter() {
      if (this.profileTypeFilter !== 'SUPPLIER' && this.profileTypeFilter !== 'ALL') {
        this.sectorFilter = 0;
      }
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


    sectorList() {

      let map = {};

      this.vendors.forEach(v => {
        v.sectors.forEach(s => {
          map[s.sector.id] = s.sector;
        })
      })

      return Object.values(map);
    },

    countryList() {
      // Create a map of unique country codes
      let map = {};

      this.vendors.forEach(v => {
        // Based on the issue description, the country code is in company.countryCode
        if (v.company && v.company.countryCode) {
          map[v.company.countryCode] = v.company.countryCode;
        }
      });

      return Object.values(map);
    },

    filteredVendors() {

      let vendors = this.vendors;

      if (this.sectorFilter > 0) {
        vendors = this.vendors.filter((v) => {
          return v.sectors.filter(s => {
            return s.sector.id === this.sectorFilter;
          }).length > 0
        });
      }
      if (this.profileTypeFilter !== 'ALL') {
        vendors = this.vendors.filter((v) => {
          return v.profileType === this.profileTypeFilter;
        });
      }
      // Filter by country if not ALL
      if (this.countryFilter !== 'ALL') {
        vendors = vendors.filter((v) => {
          return v.company && v.company.countryCode === this.countryFilter;
        });
      }
      // Filter by vendor name (ignoring case)
      if (this.vendorNameFilter.trim() !== "") {
        const keyword = this.vendorNameFilter.toLowerCase();
        vendors = vendors.filter((v) =>
            v.verifiedCompany.name.toLowerCase().includes(keyword)
        );
      }

      // Sort vendors by verifiedCompany.name using selected order
      vendors.sort((a, b) => {
        const nameA = a.verifiedCompany.name.toLowerCase();
        const nameB = b.verifiedCompany.name.toLowerCase();

        if (nameA < nameB) return this.vendorSortOrder === 'asc' ? -1 : 1;
        if (nameA > nameB) return this.vendorSortOrder === 'asc' ? 1 : -1;
        return 0;
      });
      return vendors;

    }
  },
  mounted() {

    this.getVendorList();
    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectorListAdd = ws.filter(s => s.parent === null);
    });
    this.sectorFilter = parseInt(this.$route.query['sectorId'] || 0);
    this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
  },
  methods: {
    getCompanyAdditionalDetails(vendorId){
      // Reset vendorDetails to show loading state
      this.vendorDetails = null;
      this.showAddFileForm = false;
      this.showAddLinkForm = false;
      this.showEditLinkForm = false;
      this.resetNewFileForm();
      this.resetNewLinkForm();
      this.resetEditLinkForm();

      // Open the modal
      this.$bvModal.show('modal-vendor-details');

      // Fetch the data
      getCompanyAdditionalDetails(this.token, vendorId).then(response => {
        if (response.code === 200) {
          // Store the response data
          this.vendorDetails = response;
        } else {
          // Use the common error handling function
          handleErrors(this.$swal, response, () => {
            // Close the modal after handling the error
            this.$bvModal.hide('modal-vendor-details');
          });
        }
      }).catch(error => {
        console.error("Error fetching vendor details:", error);
        this.$swal({
          icon: 'error',
          title: this.$t("generalModal.errorTitle"),
          text: this.$t("generalModal.errorOccurred")
        });
        // Close the modal
        this.$bvModal.hide('modal-vendor-details');
      });
    },

    // File handling methods

    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        this.newFile.file = null;
        return;
      }

      // Check if adding this file would exceed the remaining storage
      const fileSize = file.size / (1024 * 1024); // Convert to MB
      const remainingStorage = parseFloat(this.vendorDetails.storage || 0);

      if (fileSize > 15) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.validationError'),
          text: this.$t('companyVendors.vendorDetails.fileSizeExceeded')
        });
        // Reset the file input
        this.$refs.fileUpload.value = '';
        this.newFile.file = null;
        return;
      }

      if (fileSize > remainingStorage) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.validationError'),
          text: this.$t('companyVendors.vendorDetails.storageLimitExceeded', {
            currentStorage: (15 - remainingStorage).toFixed(3),
            remainingStorage: remainingStorage.toFixed(3)
          })
        });
        // Reset the file input
        this.$refs.fileUpload.value = '';
        this.newFile.file = null;
        return;
      }

      // Store the file in the newFile object
      this.newFile.file = file;
    },

    resetNewFileForm() {
      this.newFile = {
        title: '',
        file: null
      };
      // Clear the file input
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.value = '';
      }
    },

    addFile() {
      if (!this.newFile.title || !this.newFile.file) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.validationError'),
          text: this.$t('companyVendors.vendorDetails.provideTitleAndFile')
        });
        return;
      }

      // Show loading indicator
      this.$swal({
        title: this.$t('companyVendors.vendorDetails.adding'),
        text: this.$t('companyVendors.vendorDetails.pleaseWait'),
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      // First upload the file
      upload(this.token, 'vendorManagement', this.newFile.file, null, true)
        .then(response => {
          if (response && response.data && response.data.code === 200 && response.data.path) {
            // File uploaded successfully, now add it to the vendor
            const fileUrl = response.data.path;
            const fileSize = this.newFile.file.size / (1024 * 1024); // Convert to MB

            // Create the request object
            const request = {
              file: fileUrl,
              type: "file",
              size: fileSize,
              companyVendorId: this.vendorDetails.vendorId,
              name: this.newFile.title
            };

            // Call the API to add the vendor file
            return addVendorFile(this.token, request);
          } else {
            throw new Error(response.data?.message || 'Failed to upload file');
          }
        })
        .then(response => {
          if (response.code === 200) {
            this.$swal({
              icon: 'success',
              title: this.$t('companyVendors.vendorDetails.fileUploaded'),
              text: this.$t('companyVendors.vendorDetails.fileUploadedSuccess')
            });

            // Reset the form
            this.showAddFileForm = false;
            this.resetNewFileForm();

            // Refresh vendor details
            this.getCompanyAdditionalDetails(this.vendorDetails.vendorId);
          } else {
            throw new Error(response.message || 'Failed to add vendor file');
          }
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: this.$t('companyVendors.vendorDetails.uploadError'),
            text: error.message || this.$t('generalModal.errorOccurred')
          });
        });
    },

    deleteFile(file) {
      this.$swal({
        title: this.$t('companyVendors.vendorDetails.areYouSure'),
        text: this.$t('companyVendors.vendorDetails.cantRevert'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('companyVendors.vendorDetails.yesDelete'),
        cancelButtonText: this.$t('companyVendors.vendorDetails.cancel'),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
          // Show loading indicator
          this.$swal({
            title: this.$t('companyVendors.vendorDetails.deleting'),
            text: this.$t('companyVendors.vendorDetails.pleaseWait'),
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });

          // Extract the document ID from the file object
          const docId = file.id;
          const companyVendorId = this.vendorDetails.vendorId;

          // Call the API to delete the vendor file
          deleteVendorFile(this.token, docId, companyVendorId)
            .then(response => {
              if (response.code === 200) {
                this.$swal({
                  icon: 'success',
                  title: this.$t('companyVendors.vendorDetails.fileDeleted'),
                  text: this.$t('companyVendors.vendorDetails.fileDeletedSuccess')
                });

                // Refresh vendor details
                this.getCompanyAdditionalDetails(this.vendorDetails.vendorId);
              } else if (response.code === 403) {
                // Handle 403 error
                handleErrors(this.$swal, response, () => {
                  // Optional callback after error is displayed
                });
              } else {
                throw new Error(response.message || 'Failed to delete vendor file');
              }
            })
            .catch(error => {
              this.$swal({
                icon: 'error',
                title: this.$t('companyVendors.vendorDetails.deleteError'),
                text: error.message
              });
            });
        }
      });
    },

    // Link handling methods
    resetNewLinkForm() {
      this.newLink = {
        title: '',
        url: ''
      };
    },

    resetEditLinkForm() {
      this.editLink = {
        title: '',
        url: ''
      };
      this.editingLink = null;
    },

    addLink() {
      if (!this.newLink.title || !this.newLink.url) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.validationError'),
          text: this.$t('companyVendors.vendorDetails.provideTitleAndUrl')
        });
        return;
      }

      // Validate URL format
      if (!this.isValidUrl(this.newLink.url)) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.invalidUrl'),
          text: this.$t('companyVendors.vendorDetails.enterValidUrl')
        });
        return;
      }

      // Show loading indicator
      this.$swal({
        title: this.$t('companyVendors.vendorDetails.adding'),
        text: this.$t('companyVendors.vendorDetails.pleaseWait'),
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      // Create the request object for a link
      const request = {
        file: this.newLink.url, // Using the URL as the file path
        type: "url", // Changed to "url" as per issue description
        size: 0, // Links don't have a size
        companyVendorId: this.vendorDetails.vendorId,
        name: this.newLink.title // Added name field as per updated VendorFileRequest DTO
      };

      // Call the API to add the vendor link
      addVendorFile(this.token, request)
        .then(response => {
          if (response.code === 200) {
            this.$swal({
              icon: 'success',
              title: this.$t('companyVendors.vendorDetails.linkAdded'),
              text: this.$t('companyVendors.vendorDetails.linkAddedSuccess')
            });

            // Reset the form
            this.showAddLinkForm = false;
            this.resetNewLinkForm();

            // Refresh vendor details
            this.getCompanyAdditionalDetails(this.vendorDetails.vendorId);
          } else {
            throw new Error(response.message || 'Failed to add vendor link');
          }
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: this.$t('companyVendors.vendorDetails.addError'),
            text: error.message
          });
        });
    },

    deleteLink(link) {
      this.$swal({
        title: this.$t('companyVendors.vendorDetails.areYouSure'),
        text: this.$t('companyVendors.vendorDetails.cantRevert'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('companyVendors.vendorDetails.yesDelete'),
        cancelButtonText: this.$t('companyVendors.vendorDetails.cancel'),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
          // Show loading indicator
          this.$swal({
            title: this.$t('companyVendors.vendorDetails.deleting'),
            text: this.$t('companyVendors.vendorDetails.pleaseWait'),
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });

          // Extract the document ID from the link object
          const docId = link.id;
          const companyVendorId = this.vendorDetails.vendorId;

          // Call the API to delete the vendor link
          deleteVendorFile(this.token, docId, companyVendorId)
            .then(response => {
              if (response.code === 200) {
                this.$swal({
                  icon: 'success',
                  title: this.$t('companyVendors.vendorDetails.linkDeleted'),
                  text: this.$t('companyVendors.vendorDetails.linkDeletedSuccess')
                });

                // Refresh vendor details
                this.getCompanyAdditionalDetails(this.vendorDetails.vendorId);
              } else if (response.code === 403) {
                // Handle 403 error
                handleErrors(this.$swal, response, () => {
                  // Optional callback after error is displayed
                });
              } else {
                throw new Error(response.message || 'Failed to delete vendor link');
              }
            })
            .catch(error => {
              this.$swal({
                icon: 'error',
                title: this.$t('companyVendors.vendorDetails.deleteError'),
                text: error.message
              });
            });
        }
      });
    },

    openEditLinkForm(link) {
      // Store the link being edited
      this.editingLink = link;

      // Populate the edit form with the link's current values
      this.editLink = {
        title: link.title,
        url: link.value
      };

      // Show the edit form
      this.showEditLinkForm = true;

      // Hide the add form if it's open
      this.showAddLinkForm = false;
    },

    cancelEditLink() {
      // Hide the edit form
      this.showEditLinkForm = false;

      // Reset the form
      this.resetEditLinkForm();
    },

    updateLink() {
      if (!this.editLink.title || !this.editLink.url) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.validationError'),
          text: this.$t('companyVendors.vendorDetails.provideTitleAndUrl')
        });
        return;
      }

      // Validate URL format
      if (!this.isValidUrl(this.editLink.url)) {
        this.$swal({
          icon: 'error',
          title: this.$t('companyVendors.vendorDetails.invalidUrl'),
          text: this.$t('companyVendors.vendorDetails.enterValidUrl')
        });
        return;
      }

      // Show loading indicator
      this.$swal({
        title: this.$t('companyVendors.vendorDetails.updating'),
        text: this.$t('companyVendors.vendorDetails.pleaseWait'),
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      // Create the request object for updating the link
      const request = {
        file: this.editLink.url, // Using the URL as the file path
        type: "url", // Type is url for links
        size: 0, // Links don't have a size
        companyVendorId: this.vendorDetails.vendorId,
        name: this.editLink.title // Title of the link
      };

      // Call the API to update the vendor link
      updateVendorFile(this.token, this.editingLink.id, request)
        .then(response => {
          if (response.code === 200) {
            this.$swal({
              icon: 'success',
              title: this.$t('companyVendors.vendorDetails.linkUpdated'),
              text: this.$t('companyVendors.vendorDetails.linkUpdatedSuccess')
            });

            // Hide the edit form
            this.showEditLinkForm = false;

            // Reset the form
            this.resetEditLinkForm();

            // Refresh vendor details
            this.getCompanyAdditionalDetails(this.vendorDetails.vendorId);
          } else {
            throw new Error(response.message || 'Failed to update vendor link');
          }
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: this.$t('companyVendors.vendorDetails.updateError'),
            text: error.message
          });
        });
    },

    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    setExpiryDate(taxId, date) {
      const formattedDate = date?.toISOString().split('T')[0];
      updateVendorExpiryDate(this.token, taxId, formattedDate).then((response) => {
        if (response.code === 200) {
          this.$swal({icon: 'success', title: this.$t("companyVendors.successfullyUpdated")});
          this.getVendorList();
        } else {
          this.$swal({icon: 'error', title: this.$t("generalModal.errorOccurred")});
        }
      });
    },

    // İstəsək, expiryDate üçün recall metodu da əlavə edilir
    recallVendorExpiry() {
      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        text: this.$t("companyVendors.recallVendorExpiryConfirmation"),
        icon: "info",
        showCancelButton: true,
        confirmButtonText: this.$t("companyVendors.continue"),
        cancelButtonText: this.$t("generalModal.buttonCancel"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to the vendor forms page
          window.location.href = "/dashboard/vendorManagement/forms";
        }
      });
    },
    setDate(id, date) {
      const formattedDate = date?.toISOString().split('T')[0];
      updateVendorDeadline(this.token, id, formattedDate).then((response) => {
        if (response.code === 200) {
          this.$swal({icon: 'success', title: this.$t("companyVendors.successfullyUpdated")});
          this.getVendorList();
        } else {
          this.$swal({icon: 'error', title: this.$t("generalModal.errorOccurred")});
        }
      });
    },
    recallVendor(requestId) {
      this.$swal({
        text: this.$t("companyVendors.sendForRenewal"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("generalModal.yes"),
        cancelButtonText: this.$t("vendorManagementDeleted.cancel"),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      }).then((result) => {
        if (result.isConfirmed) {
          // Call recallRequest without a reason (empty string passed)
          recallRequest(this.token, requestId, this.$t("companyVendors.renewalTime"))
              .then((response) => {
                if (response.code === 200) {
                  this.$swal(
                      this.$t("generalModal.successTitle"),
                      this.$t("companyVendors.formRenewedSuccessfully"),
                      "success"
                  );
                  this.getVendorList(); // Refresh the vendor list if needed
                } else {
                  this.$swal(
                      this.$t("generalModal.errorTitle"),
                      response.message,
                      "error"
                  );
                }
              }).catch(error => {
            console.error("Error renewing form:", error);
            this.$swal(
                this.$t("generalModal.errorTitle"),
                this.$t("generalModal.errorOccurred"),
                "error"
            );
          });
        }
      });
    },
    deleteVendor(taxId) {
      this.$swal({
        title: this.$t("vendorManagementDeleted.deleteConfirm"),
        text: this.$t("vendorManagementDeleted.deleteVendorConfirm"),
        icon: "warning",
        input: "textarea",
        inputPlaceholder: this.$t("vendorManagementDeleted.reasonPlaceholder"),
        inputAttributes: {
          'aria-label': this.$t("general.reason")
        },
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("vendorManagementDeleted.cancel"),
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        preConfirm: (reason) => {
          if (!reason) {
            this.$swal.showValidationMessage(this.$t("vendorManagementDeleted.reasonRequired"));
          }
          return reason;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const reason = result.value;
          addDeletedVendor(this.token, taxId, reason).then((response) => {
            if (response.code === 200) {
              this.$swal(this.$t("generalModal.successTitle"), this.$t("generalModal.deleted"), "success");
              this.getVendorList(); // Refresh the vendor list
            } else {
              // Use the common error handling function for all other errors including 403
              handleErrors(this.$swal, response, null);
            }
          }).catch(error => {
            console.error("Error deleting vendor:", error);
            this.$swal(this.$t("generalModal.errorTitle"), this.$t("generalModal.errorOccurred"), "error");
          });
        }
      });
    }
    ,
    onProfileTypeChange() {
      if (this.selectedProfileType !== 'SUPPLIER') {
        this.selectedSectors = []; // Clear sectors if profile type is not SUPPLIER
      }
    },
    selectCompany(company) {
      this.selectedCompanyId = company.id; // Set selected company's ID
    },
    addVendorToList() {
      this.$bvModal.show('modal-add-vendor');

    },
    resetModal() {
      this.searchForm.name = '';
      this.searchForm.taxId = '';
      this.companies = [];
      this.modalLoading = false;
    },
    async searchCompany() {
      if (this.searchForm.name === '' && this.searchForm.taxId === '') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: this.$t("vendorAddModal.searchError")
        });
        return;
      } else if (this.searchForm.name?.length < 3 && this.searchForm.taxId === '') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: this.$t("companyVendors.companyNameMinLength")
        });
        return;
      }
      this.modalLoading = true;
      try {
        // Call the async function to fetch company data
        searchCompanyByNameOrTaxId(this.token, this.searchForm.name, this.searchForm.taxId).then(data => {
          this.companies = data.companies;
        })

      } catch (error) {
        console.error("Error searching for company:", error);
        this.companies = [];
      } finally {
        this.modalLoading = false;
      }
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    addCompanyToVendor() {
      if (this.selectedSectors.length === 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: this.$t("companyVendors.sectorSelectionRequired")
        });
        return;
      }
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",");

      addCompanyToVendorManagment(this.token, this.selectedCompanyId, this.selectedProfileType, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            icon: 'success'
          }).then(() => {
            window.location.reload();
          })
        } else if (data.code === 406) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("companyVendors.companyInDeletedList"),
            icon: 'warning'
          })
        } else {
          // Use the common error handling function for all other errors including 403
          handleErrors(this.$swal, data, null);
        }
      }).catch(error => {
        console.error("Error adding company to vendor management:", error);
        this.$swal({
          icon: 'error',
          title: this.$t("generalModal.errorTitle"),
          text: this.$t("generalModal.errorOccurred")
        });
      })
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getVendorList() {

      getVendorList(this.token).then((list) => {
        this.loaded = true;
        this.vendors = list.map(vendor => ({...vendor, isDatePickerOpen: false}));

        // Log the first vendor object to understand its structure
        if (this.vendors.length > 0) {
          ('Vendor object structure:', this.vendors[0]);
        }
      });

    },

    openChangeSectorModal(vendor) {
      this.selectedVendor = vendor;
      this.selectedProfileType = 'SUPPLIER';

      // Initialize selected sectors
      this.selectedSectors = vendor.sectors.map(s => {
        // Find the matching sector in sectorListAdd
        return this.sectorListAdd.find(sector => sector.id === s.sector.id) || s.sector;
      });

      this.$bvModal.show('modal-change-sector');
    },

    resetChangeSectorModal() {
      this.selectedVendor = null;
      this.selectedProfileType = 'SUPPLIER';
      this.selectedSectors = [];
    },

    updateVendorSectors() {
      if (this.selectedSectors.length === 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: "error",
          text: this.$t("companyVendors.sectorSelectionRequired")
        });
        return;
      }

      this.modalLoading = true;

      let sectorIds = this.selectedSectors.map(function (elem) {
        return elem.id;
      });

      updateSectorForOne(this.token, this.selectedVendor.id, sectorIds)
        .then(data => {
          this.modalLoading = false;

          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              icon: 'success',
              text: this.$t("companyVendors.sectorSuccessfullyUpdated")
            }).then(() => {
              this.$bvModal.hide('modal-change-sector');
              this.getVendorList(); // Refresh the vendor list
            });
          } else {
            this.$swal({
              title: this.$t("generalModal.errorTitle"),
              text: data.message || this.$t("generalModal.errorOccurred"),
              icon: 'error'
            });
          }
        })
        .catch(error => {
          this.modalLoading = false;
          this.$swal({
            title: this.$t("generalModal.errorTitle"),
            text: this.$t("generalModal.errorOccurred"),
            icon: 'error'
          });
          console.error("Error updating vendor sectors:", error);
        });
    },


    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },

    confirmRequest(data) {
      this.confirmRequestDetails = data;
      this.$bvModal.hide('modal-vendor-request');
      this.$bvModal.show('modal-request-confirm')
    },


  }

}
</script>

<style scoped>
.compact-dropzone {
  min-height: 120px !important; /* Reduce the minimum height */
  padding: 10px !important; /* Reduce padding */
  border: 1px dashed #ccc !important; /* Thinner border */
}

.compact-dropzone .dz-message {
  margin: 0.5em 0 !important; /* Reduce margin */
  font-size: 0.9em !important; /* Smaller font */
}

.compact-dropzone .dz-preview {
  margin: 5px !important; /* Reduce margin between previews */
  min-height: 80px !important; /* Smaller preview height */
}

.compact-dropzone .dz-preview .dz-image {
  width: 80px !important; /* Match the thumbnail width */
  height: 80px !important; /* Match the thumbnail height */
}

.compact-dropzone .dz-preview .dz-details {
  padding: 1px !important; /* Reduce padding */
}

.compact-dropzone .dz-preview .dz-progress {
  height: 8px !important; /* Thinner progress bar */
  margin-top: 5px !important; /* Less margin */
  margin-bottom: 5px !important;
}

.compact-dropzone .dz-preview .dz-error-message {
  font-size: 0.8em !important; /* Smaller error text */
}

.small-hint {
  font-size: 0.75em !important; /* Smaller hint text */
  margin-top: 2px !important; /* Less margin */
  line-height: 1.2 !important; /* Tighter line height */
  opacity: 0.7; /* Slightly faded for less visual prominence */
}

.compact-form-group {
  margin-bottom: 0.5rem !important; /* Reduced bottom margin */
}

.small-label {
  font-size: 0.85em !important; /* Smaller label text */
  margin-bottom: 0.2rem !important; /* Less margin */
}

.compact-form-container {
  border-width: 1px !important; /* Thinner border */
  box-shadow: none !important; /* Remove any shadow */
}

.small-heading {
  font-size: 0.95em !important; /* Smaller heading text */
  font-weight: 600 !important; /* Slightly less bold */
}
</style>
<style>
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.text-blink {
  animation: blink 1s infinite;
}

/* Fix for modal close button transparency issue */
.modal-header .close {
  opacity: 1 !important;
}

.custom-file-upload {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 15px;
  text-align: center;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

.custom-file-upload:hover {
  border-color: #007bff;
  background-color: #f1f8ff;
}

.custom-file-upload input[type="file"] {
  width: 100%;
}

.small-label {
  font-size: 0.875rem;
  font-weight: 500;
}

.small-hint {
  font-size: 0.75rem;
}

.compact-form-group {
  margin-bottom: 0.75rem;
}
</style>
